import {AttributeValue} from "./AttributeValue";

export class Attribute{
      id:number;
      name:string="";
      language:string="";
}